/**
 * Not yet defined in Figma. Values are MUI defaults — re-sync when design exposes motion tokens.
 * Figma source file: https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-
 */
export const motionDuration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195,
} as const;

export const motionEasing = {
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
} as const;
